<template>
  <div>
    <div class="row">
      <div class="col-xl-12 col-lg-12 col-md-12">
        <shelve-form> </shelve-form>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12 col-lg-11 col-md-10">
        <shelved></shelved>
      </div>
    </div>
  </div>
</template>
<script>
import ShelveForm from "./Shelve/ShelveForm.vue";
import Shelved from "@/pages/Shelved.vue";
export default {
  components: {
    ShelveForm,
    Shelved
  },
};
</script>
<style>
</style>
